"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importStar(require("styled-components"));

var Icon_1 = require("../../Icon/Icon");

var EyeIconContainer = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    right: 52px;\n"], ["\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    right: 52px;\n"])));
var IconNamesEnum;

(function (IconNamesEnum) {
  IconNamesEnum["secure"] = "eye-outline";
  IconNamesEnum["notSecure"] = "eye-off-outline";
})(IconNamesEnum || (IconNamesEnum = {}));

var EyeIcon = function EyeIcon(props) {
  var action = props.action,
      isSecure = props.isSecure,
      theme = props.theme;
  var name = isSecure ? IconNamesEnum.secure : IconNamesEnum.notSecure;
  return react_1.default.createElement(EyeIconContainer, {
    onPress: function onPress() {
      return action();
    }
  }, react_1.default.createElement(Icon_1.Icon, {
    name: name,
    size: Icon_1.IconSizeEnum.small,
    color: theme.colors.gray
  }));
};

exports.default = styled_components_1.withTheme(EyeIcon);
var templateObject_1;